<template>
    <div class="az-sidebar">
      <div class="az-sidebar-header">
        <a v-if="logo_groups.shadforth.includes(email)" href="https://www.sfg.com.au/" target="_blank" class="az-logo">
          <img src="../assets/img/new/shadforth_logo.png" style="height:32px" alt="">
        </a>
        <a v-else href="" class="az-logo" style="color:#1c273c">
          <img style="width:23px;height:23px;" src="../assets/img/new/TAS-logo1.png" alt="">
          TripleA<span style="color:#7987a1">Super</span><br>
        </a>
      </div><!-- az-sidebar-header -->
      <!-- <div class="az-sidebar-header" style="height:30px;padding-bottom:30px">
        <a href="" class="az-logo" style="color:#1c273c"><span style="color:#7987a1">
          <img style="width:20px;height:20px;" src="../assets/img/new/preset-logo1.png" alt="">
          Preset</span>Super</a>
      </div> -->
      <div class="az-sidebar-loggedin">
        <!-- <div class="az-img-user online"><img :src="image" alt=""></div> -->
        <div class="media-body tx-13" style='margin-left:0'>
          <h6>{{isSample?'Sample User':firstname+' '+lastname}}</h6>
          <span>{{isSample?'Sample Company Pty Ltd':company}}</span>
        </div><!-- media-body -->
      </div><!-- az-sidebar-loggedin -->
      <router-link class="nav-link" :to="{path:'/forms/',query:{brand:brand}}"> Create an SMSF </router-link>
      <router-link class="nav-link" :to="{path:'/forms/',query:{brand:brand}}"> Transfer an SMSF </router-link>
      <div class="az-sidebar-body">
        <ul class="nav">
          <!-- <li class="nav-label">Main Menu</li> -->
          <li class="nav-item " v-bind:class={active:isBOActive,show:isBOActive} v-show="isBO===true">
            <router-link type="button" class="nav-link" to="/businessoverview"><i class="typcn typcn-chart-bar-outline"></i>Consolidated Business Overview</router-link>
            <!-- <ul class="nav-sub">
              <li class="nav-sub-item"><a href="" class="nav-sub-link">Fund Status</a></li>
              <li class="nav-sub-item"><a href="" class="nav-sub-link">Cash at Bank</a></li>
              <li class="nav-sub-item"><a href="" class="nav-sub-link">Contributions</a></li>
              <li class="nav-sub-item"><a href="" class="nav-sub-link">Minimum Pension Status</a></li>
              <li class="nav-sub-item"><a href="" class="nav-sub-link">Tax Lodgements</a></li>
              <li class="nav-sub-item"><a href="" class="nav-sub-link">Insurance</a></li>
              <li class="nav-sub-item"><a href="" class="nav-sub-link">Privacy Policy</a></li>
            </ul> -->
          </li>
          <li class="nav-item" v-bind:class={active:isAdActive,show:isAdActive} v-show="!isBOActive || isBO===false">
            <router-link href="" class="nav-link with-sub" :to='"/adviserdashboard/"'><i class="typcn typcn-device-laptop"></i>Adviser Dashboard</router-link>
            <ul class="nav-sub">
              <li class="nav-sub-item">
                <router-link class="nav-sub-link" :to='{path:"/adviserdashboard/fund_status_adviser",query:{page:"Fund Status"}}'>Fund Status</router-link>
              </li>
              <li class="nav-sub-item">
                <router-link class="nav-sub-link" :to='{path:"/adviserdashboard/cash_at_bank",query:{page:"Cash at Bank"}}'>Cash at Bank</router-link>
              </li>
              <li class="nav-sub-item">
                <router-link class="nav-sub-link" :to='{path:"/adviserdashboard/contributions",query:{page:"Contributions"}}'>Contributions</router-link>
              </li>
              <li class="nav-sub-item">
                <router-link class="nav-sub-link" :to='{path:"/adviserdashboard/min_pension",query:{page:"Minimum Pension Status"}}'>Minimum Pension Status</router-link>
              </li>
              <li class="nav-sub-item">
                <router-link class="nav-sub-link" :to='{path:"/adviserdashboard/tax",query:{page:"Tax Lodgements"}}'>Tax Lodgements</router-link>
              </li>
              <li class="nav-sub-item">
                <router-link class="nav-sub-link" :to='{path:"/adviserdashboard/insurance",query:{page:"Insurance"}}'>Insurance</router-link>
              </li>
              <!-- <li class="nav-sub-item"><a href="" class="nav-sub-link">Privacy Policy</a></li> -->
            </ul>
          </li><!-- nav-item -->
          <li class="nav-item" v-bind:class={active:isFundActive,show:isFundActive} v-show="!isAdActive">
            <router-link href="" class="nav-link with-sub" :to="{path:'/funddashboard/'+fund_code,query:{name:name}}"><i class="typcn typcn-device-laptop"></i>Fund Dashboard</router-link>
            <ul class="nav-sub">
              <li class="nav-sub-item">
                  <router-link class="nav-sub-link" :to="{path:'/funddashboard/'+fund_code+'/investments/',query:{name:name,brand:brand,page:'Investments'}}">Investments</router-link>
              </li>
              <li class="nav-sub-item">
                  <router-link class="nav-sub-link" :to="{path:'/funddashboard/'+fund_code+'/memberbasic/',query:{name:name,brand:brand,page:'Member Basic Details'}}">Member Basic Details</router-link>
              </li>
              <li class="nav-sub-item">
                  <router-link class="nav-sub-link" :to="{path:'/funddashboard/'+fund_code+'/contributions/',query:{name:name,brand:brand,page:'Contributions'}}">Contributions</router-link>
              </li>
              <li class="nav-sub-item">
                  <router-link class="nav-sub-link" :to="{path:'/funddashboard/'+fund_code+'/pensions/',query:{name:name,brand:brand,page:'Pensions'}}">Pensions</router-link>
              </li>
              <li class="nav-sub-item" v-if="isBGL===false">
                  <router-link class="nav-sub-link" :to="{path:'/funddashboard/'+fund_code+'/memberbenefit/',query:{name:name,brand:brand,page:'Member Benefit Estimates'}}">Member Benefit Estimates</router-link>
              </li>
              <li class="nav-sub-item">
                  <router-link class="nav-sub-link" :to="{path:'/funddashboard/'+fund_code+'/reports/',query:{name:name,brand:brand,page:'Reports'}}">Reports</router-link>
              </li>
              <li class="nav-sub-item">
                  <router-link class="nav-sub-link" :to="{path:'/funddashboard/'+fund_code+'/documents/',query:{name:name,brand:brand,page:'Documents'}}">Documents</router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" :to="{path:'/servicecenter/'}"><i class="typcn typcn-mail"></i>Service Centre</router-link>
          </li>
          <li class="nav-item">
              <a href="https://lf6nb16fqqqhogc-taspdwdb.adb.ap-sydney-1.oraclecloudapps.com/ords/f?p=147" target="_blank" class="nav-link"><i class="typcn typcn-info-large"></i>Online Investment Strategy</a>
          </li>

          <li class="nav-item">
            <a 
              href="https://lf6nb16fqqqhogc-taspdwdb.adb.ap-sydney-1.oraclecloudapps.com/ords/f?p=140" 
              target="_blank" 
              class="nav-link"
            >
              <i class="typcn typcn-edit"></i>
              Query Management Portal
              <span v-if="total_outstanding_queries > 0" class="badge-circle">{{ total_outstanding_queries }}</span>
            </a>
            <!-- <ul class="nav-sub">
              <li class="nav-sub-item"><a href="#" class="nav-sub-link">Outstanding Queries</a></li>
            </ul> -->
          </li><!-- nav-item 
          <li class="nav-item">
            <a v-if="isBGL===false" target="_blank" href="https://app.class.com.au/my/login?ReturnUrl=%2fconnect%2fauthorize%3fresponse_type%3did_token%26client_id%3d4ffd9652-399b-4ccd-b76c-2d4917bcdd71%26redirect_uri%3dhttps%253A%252F%252Fclient.class.com.au%252Fapp%252Ftokenhandler.html%26state%3d6c8ad1db-5261-4b91-8278-4e53a6d6f19c%26scope%3dopenid%2520fund.read%2520business.fund.list%2520email%2520profile%26x-client-SKU%3dJs%26x-client-Ver%3d1.0.1-class%26whitelabel%3dclass%26clientview%3dtrue%26nonce%3db4f8364d-77a4-4e2a-b791-538378e43115&ReturnCookie=53bc81be-7824-4462-825a-b8498fbedf6c&whitelabel=class&clientview=true" class="nav-link"><img style="width:16px;height:16px;margin-right: 10px;" src="../assets/img/new/class-logo.png" alt="">Class Administration</a>
            <a v-else href="https://sso.bgl360.com.au/" target="_blank" class="nav-link"><img style="width:16px;height:16px;margin-right: 10px;" src="../assets/img/new/BGL_Dark.png" alt="">BGL360 Administration</a>
          </li> nav-item -->
          <li class="nav-item" v-show="isBOActive">
            <a target="_blank" href="https://lf6nb16fqqqhogc-taspdwdb.adb.ap-sydney-1.oraclecloudapps.com/ords/r/tasit/integra-saas/" class="nav-link"><i class="typcn typcn-device-tablet"></i>Accounting Business Dashboard</a>
          </li><!-- nav-item -->
          <!-- <li class="nav-item">
            <a href="" class="nav-link"><img style="width:22px;height:18px;margin-right: 4px;" src="../assets/img/new/techhub_logo.png" alt="">TechHub</a>
          </li> -->
          <li class="nav-item">
            <span @click="isSubShow=!isSubShow" class="nav-link with-sub"><i class="typcn typcn-archive"></i>Resources</span>
            <!-- class & bgl resources -->
            <ul v-show="isSubShow" class="nav-sub">
              <li class="nav-sub-item">
                <div>
                  <li class="nav-sub-item">
                  <div>
                  <router-link class="nav-sub-link" :to="{path:'/forms/',query:{brand:brand}}">
                    &nbsp; Forms & Templates</router-link>
                  </div>
              </li>
              </div>
              </li>
              <li class="nav-sub-item">
                <div>
                    <a :href="userguide" target="_blank" class="nav-sub-link">
                      &nbsp; User Guide         
                    </a>
                </div>
              </li>
              
              <li style="height: 40px;
              display: flex;
              align-items: center;
              padding: 0;
              font-weight: 500;
              font-size: 13px;
              color: #1c273c;
              padding-bottom: 2px;">Approved list of Data Feeds</li>
              <li class="nav-sub-item">
                <div>
                  <a :href="banks" target="_blank" class="nav-sub-link">
                    &nbsp; - Banks
                  </a>
              </div>
              </li>
              <li class="nav-sub-item">
                <div>
                  <a :href="brokers" target="_blank" class="nav-sub-link">
                    &nbsp; - Brokers
                  </a>
              </div>
              </li>
              <li class="nav-sub-item">
                <div>
                  <a :href="wraps" target="_blank" class="nav-sub-link">
                    &nbsp; - Wraps - Platforms
                  </a>
              </div>
              </li>
              <li class="nav-sub-item">
                <div>
                  <a :href="privacy" target="_blank" class="nav-sub-link">
                    &nbsp; Privacy Policy
                  </a>
              </div>
              </li>
            </ul>
          </li><!-- nav-item -->
        </ul><!-- nav -->
      </div><!-- az-sidebar-body -->
      <div class="card card-dashboard-events" style="border:none">
        <div class="card-header">
          <!-- <h6 class="card-title">December 2021</h6> -->
          <h5 class="card-subtitle">News & Publications</h5>
        </div><!-- card-header -->
        <div class="card-body">
          <div class="list-group">
            <div
              class="list-group-item"
              v-for="(item, idx) in processedNews"
              :key="item.link"
            >
              <div class="event-indicator" :class="indicatorClass(idx)"></div>

              <label>
                {{ item.dateLabel }}
                <span>{{ item.weekday }}</span>
              </label>

              <div class="mg-b-10"><!-- optional image slot --></div>

              <h6>
                <u>
                  <a
                    :href="item.link"
                    style="color:black"
                    target="_blank"
                    rel="noopener"
                  >
                    {{ item.title }}
                  </a>
                </u>
              </h6>

              <small v-html="item.summaryProcessed"></small>
            </div>
          </div>
        </div><!-- card-body -->
      </div><!-- card -->
      <!-- <div>
        <NewsFeed />
      </div> -->
    </div><!-- az-sidebar -->
</template>


<script>
// import NewsFeed from './NewsFeed.vue'
export default {
  name: 'Sidebar',
  components:{
    // NewsFeed
  },
  props: {
    
  },
  data(){
    return{
      userguide:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Triple+A+%26+Preset+Adviser+%26+Fund+User+Guide+Nov+2022.pdf',
      tas_new:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/TAS+App+for+New+SMSF+FY2023+FEV+01092022.pdf',
      tas_transfer:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/TAS+App+for+Transfer+SMSF+FY2023+EV+01092022.pdf',
      bstar_report:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Bstar+2020.21+Accounting+Industry+Insights+Report.pdf',
      bstar_exe:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Bstar+2020.21+Accounting+Industry+Insights+Report+-+Executive+Summary.pdf',
      banks:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Banks.pdf',
      brokers:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Brokers.pdf',
      wraps:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Wraps+-+Platforms.pdf',
      privacy:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Triple+A+-+Preset+Super+Privacy+Policy+0620.pdf',
      choose:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Choosing+between+Triple+A+%26+Preset+Admin+Services+SMSF+Dec19.pdf',
      logo_groups:{
        shadforth:['bgl_testing_acc@tripleasuper.com.au'],
      },
      isSample:false,
      firstname:'',
      lastname:'',
      email:'',
      company:'',
      isBO: false,
      isBGL:false,
      isBOActive:true,
      isAdActive:true,
      isFundActive:false,
      isSubShow:false,
      isThirdPartyShow:false,
      brand:'',
      fund_code:'',
      name:'',
      newsData: [],
      total_outstanding_queries: 0,
    }
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.getHeader()
    this.getAccuriumFeeds()
    this.get_outstanding_queries_sum()
  },
  watch:{
    $route: function(newVal){
      this.changeMenu(newVal.path);
      this.fund_code = newVal.params.fund_code
      this.brand = localStorage.getItem('brand_code')
      this.name = newVal.query.name
    }
    
  },

  computed: {
    processedNews() {
      return (this.newsData || []).map(raw => {
        const { dateLabel, weekday } = this.makeDateParts(raw.published_at || Date.now())
        return {
          ...raw,
          dateLabel,
          weekday,
          summaryProcessed: this.forceLinksNewTab(raw.summary || '')
        }
      })
    }
  },

  methods: {
    getAccuriumFeeds: function(){
        this.$api.adviserdashboard_api.get_accrium_feeds().then(response =>{
            this.newsData = response.data;
        }) 
    },
    get_outstanding_queries_sum: function(){
        this.$api.bo_api.get_outstanding_queries_sum().then(response =>{
            this.total_outstanding_queries = response.data['total_outstanding_queries'];
        })
    },
    getHeader: function(){
      const userdetail = JSON.parse(localStorage.getItem('userdetail'));
      // console.log(JSON.parse(userdetail));
      this.isSample=userdetail['sample'];
      this.firstname = userdetail['firstname'];
      this.lastname = userdetail['lastname'];
      this.email = userdetail['email'];
      this.company = userdetail['company'];
      this.isBO = userdetail['isBO'];
      this.isBGL= userdetail['isBGL'];
      this.image = "https://ui-avatars.com/api/?bold=true&background=5b47fb&color=fff&name="+this.firstname+"+"+this.lastname;
      this.fund_code = this.$route.params.fund_code
      this.brand = localStorage.getItem('brand_code')
      this.name = this.$route.query.name
    },
    changeMenu: function(path){
      if(path.includes('/businessoverview')){
        this.isBOActive = true;
      }else if(path.includes('/servicecenter')){
        this.isBOActive = true;
      }else if(path.includes('/adviserdashboard')){
        this.isBOActive = false;
        this.isAdActive = true;
      }else if(path.includes('/funddashboard')){
        this.isBOActive = false;
        this.isAdActive = false;
        this.isFundActive = true;
      }else{
        this.isBOActive = false;
        this.isAdActive = true;
        this.isFundActive = false;
      }
    },
    indicatorClass(idx) {
      const classes = ['bg-purple', 'bg-primary', 'bg-pink']
      return classes[idx % classes.length]
    },
    makeDateParts(iso) {
      const d = new Date(iso)
      // e.g. "Aug 18"
      const dateLabel = d.toLocaleString('en-AU', {
        month: 'short',
        day: 'numeric'
      })
      // e.g. "Monday"
      const weekday = d.toLocaleString('en-AU', { weekday: 'long' })
      return { dateLabel, weekday }
    },
    forceLinksNewTab(html = '') {
      if (!html) return ''
      const doc = new DOMParser().parseFromString(html, 'text/html')
      doc.querySelectorAll('a').forEach(a => {
        a.setAttribute('target', '_blank')
        a.setAttribute('rel', 'noopener')
      })
      return doc.body.innerHTML
    },
    
  },
}

</script>

<style scoped>
.nav-sub{
  display:block;
}
#chartdiv {
        width: 100%;
        height: 300px;
      }

      .shake {
        animation: shaker 0.5s;
        animation-iteration-count: infinite;
      }

    @keyframes shaker {
      0%,
      100% {
        transform: rotate(0deg);
      }
      20%,
      60% {
        transform: rotate(6deg);
      }
      40%,
      80% {
        transform: rotate(-6deg);
      }
    }
    .badge-circle {
  display: inline-block;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  background: #d32a18;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  margin-left: 8px;
  line-height: 22px;
}
</style>
